import type { DRDrawingViewer } from "../DRDrawingViewer";
import { BaseAddEntityCommand } from "./BaseAddEntityCommand";

export interface AddEntityParams {
  /** Handle of the entity (stable identifier) */
  entityHandle: string;
  /** The original layer name to restore on redo */
  originalLayerName: string;
  /**
   * Handles of sub-entities that must hide/reappear with the entity (e.g. the
   * OdDbAttributes of a block reference). They are components of the entity, not
   * DR entities of their own, so they get no DR_META/oplog event — same rule as
   * a photo marker's attribute (see AddPhotoMarkerCommand.metaHandles).
   */
  componentHandles?: string[];
}

/**
 * Command for adding a single entity with soft-delete undo.
 * Undo moves entity to hidden layer, redo restores to original layer.
 */
export class AddEntityCommand extends BaseAddEntityCommand {
  constructor(viewer: DRDrawingViewer, params: AddEntityParams) {
    super(viewer, {
      entityHandles: [params.entityHandle, ...(params.componentHandles ?? [])],
      originalLayerName: params.originalLayerName,
    });
  }

  /** Only the head entity represents "the" created object — see componentHandles. */
  protected override get metaHandles(): string[] {
    return this.handles.slice(0, 1);
  }
}
